import { Button, Dropdown, MenuProps, Tooltip } from "antd";
import { default as classNames } from "classnames";
import { MdMoreVert } from "react-icons/md";

// Props expected from the parent component
interface PostCardMenuProps {
  isMenuLoading: boolean;
  isMenuOpen: boolean;
  menuItems: MenuProps["items"];
  handleMenuClick: MenuProps["onClick"];
  handleMenuOpenChange: (open: boolean) => void;
}

const PostCardMenu = ({
  isMenuLoading,
  isMenuOpen,
  menuItems,
  handleMenuClick,
  handleMenuOpenChange,
}: PostCardMenuProps) => {
  return (
    <Dropdown
      disabled={isMenuLoading}
      menu={{ items: menuItems, onClick: handleMenuClick }}
      onOpenChange={handleMenuOpenChange}
      trigger={["click"]}
      open={isMenuOpen}
    >
      <Tooltip title="More options">
        <Button
          className={classNames("!size-10")}
          type="text"
          onClick={(e) => {
            e.stopPropagation();
          }}
          icon={<MdMoreVert size={18} />}
        />
      </Tooltip>
    </Dropdown>
  );
};

export default PostCardMenu;
